import React from "react";
import VideoGeneration from "../base/VideoGeneration";

export default function FilmVideo(props) {
  return <VideoGeneration {...props} />;
}
